import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { searchDeveloperAppsQuery } from 'queries';
import {
  createNormalizedMap,
  handleFetchError,
  getNextPageKey,
  updatePages,
  hasNextPage,
  pushApps
} from 'action-utils';

const STATE_PROP = 'fetchDeveloperApps';

export default new AsyncActionHandler({
  name: 'fetch_developer_apps',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {},
    searchPages: {},
    apps: {}
  },
  handler({ developerProfileId, type, startIndex = 0, limit = 4 }) {
    return async (dispatch, getState) => {
      if (!developerProfileId) {
        return;
      }

      const {
        [this.stateProp]: {
          [`${developerProfileId}-${type}-limit:${limit ? limit : 'all'}`]: {
            pages
          } = {}
        }
      } = getState().registry;

      const pageKey = getNextPageKey({
        index: startIndex,
        pages
      });

      if (startIndex !== 0 && !pageKey) {
        return;
      }

      try {
        const { data: { searchResults } = {} } = await apollo.query({
          query: searchDeveloperAppsQuery,
          variables: {
            type,
            developerProfileId,
            limit: limit,
            pageKey
          },
          fetchPolicy: 'no-cache'
        });

        return {
          type,
          developerProfileId,
          limit,
          searchResults,
          pageKey
        };
      } catch (error) {
        return handleFetchError(error);
      }
    };
  },

  reduce(
    state,
    { type, developerProfileId, limit, searchResults, pageKey = 0 }
  ) {
    const {
      [this.stateProp]: {
        [`${developerProfileId}-${type}-limit:${
          limit ? limit : 'all'
        }`]: searchState = {}
      }
    } = state;

    if (!searchResults) {
      return state;
    }

    const existingApps = searchState.entries || [];
    const entries = pushApps(existingApps, searchResults.apps);

    const pages = updatePages({
      pageKey,
      pagedApps: searchResults,
      startIndex: existingApps.length,
      pages: searchState.pages
    });
    return {
      [this.stateProp]: {
        [`${developerProfileId}-${type}-limit:${limit ? limit : 'all'}`]: {
          entries,
          hasNextPage: hasNextPage(pages),
          pages
        }
      },
      apps: {
        ...state.apps,
        ...createNormalizedMap(searchResults.apps, state.apps)
      }
    };
  }
});
